import React, { HTMLAttributes } from "react";
import cn from "classnames";

const Divider = ({ className }: HTMLAttributes<HTMLButtonElement>) => {
  const dividerStyles = "w-full border-dark-grey my-3";
  return <hr className={cn(dividerStyles, className)} />;
};

export default Divider;
